import PropTypes from"prop-types";export const jutroMonthShape=PropTypes.shape({month:PropTypes.number.isRequired,year:PropTypes.number.isRequired});